import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getCourses } from '../../api/service';

function traducirModalidad(modalidad) {
    if (modalidad === 'sync') return 'Sincrónico';
    if (modalidad === 'async') return 'Asincrónico';
    if (modalidad === 'mixed') return 'Mixto';
    if (modalidad === 'presencial') return 'Presencial';
    return modalidad || 'No definida';
}

function toList(data) {
    if (Array.isArray(data)) return data;
    if (data && Array.isArray(data.results)) return data.results;
    return [];
}

export default function CursosPage() {
    const [courses, setCourses] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        let cancelled = false;
        getCourses()
            .then((data) => { if (!cancelled) setCourses(toList(data)); })
            .catch(() => { if (!cancelled) setCourses([]); })
            .finally(() => { if (!cancelled) setIsLoading(false); });
        return () => { cancelled = true; };
    }, []);

    useEffect(() => {
        document.title = 'Cursos | Somnus';
        return () => { document.title = 'Somnus'; };
    }, []);

    return (
        <main className="page-cursos font-n">
            <div className="banner-course">
                <h4>Cursos</h4>
            </div>
            <section className="page-cursos-content">
                <div className="btn-back-container">
                    <button onClick={() => navigate(-1)}>
                        <i className="ri-arrow-go-back-line d-inline d-md-none"></i><span className="d-none d-md-inline">Volver</span>
                    </button>
                </div>
                {isLoading ? (
                    <div className="loader-container">
                        <img src="/icon/carga-puntos.svg" alt="Cargando cursos Somnus" style={{ width: '180px', height: 'auto' }} />
                        <p className="txt-loading">Cargando cursos...</p>
                    </div>
                ) : courses.length > 0 ? (
                    <div className="page-cursos-grid">
                        {courses.slice(0,10).map((curso, index) => (
                            <div className="course-card page-course-card" key={curso.id || curso.code || index}>
                                <div className="img-wrapper">
                                    <img src={curso.image || "/img/course/puntos.webp"} alt={curso.name} />
                                </div>
                                <div className="card-content">
                                    <span className="label-course">Cursos</span>
                                    <p className="course-name">{curso.name}</p>
                                    <div className="course-info-row">
                                        <div className="info-item">
                                            <i className="ri-calendar-line"></i>
                                            <span>Inicio: {curso.start_date || "Por definir"}</span>
                                        </div>
                                        <div className="info-item">
                                            <i className="ri-time-line"></i>
                                            <span>{curso.duration_text || "Por definir"}</span>
                                        </div>
                                        <div className="info-item">
                                            <i className="ri-money-dollar-circle-line"></i>
                                            <span>{curso.price || "Por definir"}</span>
                                        </div>
                                        <div className="info-item">
                                            <i className="ri-macbook-line"></i>
                                            <span>{traducirModalidad(curso.modality)}</span>
                                        </div>
                                        <Link to={`/curso/${curso.code}`}>
                                            <button><span>Ver detalles</span></button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <p className="txt-resp">No hay cursos disponibles en este momento.</p>
                )}
            </section>
        </main>
    );
}
